import styled from "styled-components"


export const FoundationPage = () => {
  return (
    <StyleWrap>
      NamingConventions
    </StyleWrap>
  )
}

const StyleWrap = styled.div`

`;